import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeSettingsInfoResponse = {
  code: string;
  message: string;
  data: {
    /** 자동 로그인 여부 */
    enableKeepLogin: boolean;
    /** 채용 모집 관련 문자 수신 동의 여부 */
    allowRecruit: boolean;
    /** 야간시간 안내 문자 수신 동의 여부 */
    allowNightTime: boolean;
    /** 마지막 비밀번호 변경 일시 */
    lastPasswordChangedAt: string;
  };
};

/** @description 설정 정보 조회 api 요청에 사용되는 커스텀 훅 */
export const useGetSettingsInfo = () => {
  const queryClient = useQueryClient();

  const requestGetSettingsInfo = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: TypeSettingsInfoResponse) => void;
    onError?: (error: TypeErrorFormat) => void;
  }) => {
    const endpoint = '/labor-accounts/settings';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeSettingsInfoResponse>>({
      queryKey: ['labor-accounts', 'settings'],
      queryFn: () => axiosInstance.get(endpoint),
      gcTime: 0,
    });
    return requestHelper(() => query, onSuccess, onError);
  };

  return requestGetSettingsInfo;
};
